import { Selectable } from '@shared';
import { Tier } from '@shared-data';

export class SelectableTier extends Selectable(Tier) {}
